export default function GetParameterURL(item, history, location) {

    let value = new URLSearchParams(location.search).get(item);
    if(value === null || value.length === 0){
        return "";
    }
    return value;
}